// app/features/user-profile/services_and_hooks/activationService.ts

export interface ActivationCompleteResponse {
  success: boolean;
  message: string;
  activationComplete?: boolean;
  alreadySent?: boolean;
  sentAt?: string;
  newsletterDelivery?: {
    success: boolean;
    data?: any;
    error?: any;
  };
  status?: {
    hasOrganization: boolean;
    hasWorkflow: boolean;
    hasNewsletterSubscription: boolean;
  };
}

/**
 * Service for handling user activation completion
 */
export const activationService = {
  /**
   * Triggers activation completion check and welcome newsletter delivery
   * Call this after any action that might complete the activation flow
   */
  async triggerActivationComplete(): Promise<ActivationCompleteResponse> {
    const response = await fetch('/api/user/activation-complete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok && response.status !== 200) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to process activation completion');
    }

    const result = await response.json();
    return result;
  },
};

